'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M248 0l80 0 0 176 56 0 0 48-160 0 0-48 56 0 0-128-56 0 0-48 24 0zM24 288l80 0 0 176 56 0 0 48-160 0 0-48 56 0 0-128-56 0 0-48 24 0zM0 0L192 0 192 224 0 224 0 0zM48 48l0 128 96 0 0-128-96 0zM216 288l168 0 0 224-192 0 0-224 24 0zm24 176l96 0 0-128-96 0 0 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;